import { ColorsEnum, Text } from '@shared/widgets';

interface RecentRecipientIconProps {
  firstName?: string;
  lastName?: string;
  companyName?: string;
  accountNumber?: string;
  iban?: string;
}

export const RecentRecipientIcon = (props: RecentRecipientIconProps) => {
  return (
    <>
      <div className='flex bg-primary rounded-full w-9 h-9 min-h-9 min-w-9 mr-2'>
        <Text weight='semibold' className='m-auto' color={ColorsEnum.White}>
          {props?.firstName?.[0]} {props?.lastName?.[0]}
          {!props?.firstName?.[0] && !props?.lastName?.[0] && props?.companyName?.[0]}
          {!props?.firstName?.[0] && !props?.lastName?.[0] && !props?.companyName?.[0] && '-'}
        </Text>
      </div>
      <div className='flex flex-col'>
        <Text weight='semibold'>
          {props.firstName} {props.lastName} {props.companyName}
          {!props.firstName && !props.lastName && !props.companyName && '-'}
        </Text>
        <Text className='text-nowrap' size='xs' color={ColorsEnum.Secondary}>
          {props.iban || props.accountNumber}
        </Text>
      </div>
    </>
  );
};
